import { EMPTY_OBJECT } from '#pplx/frontend/common/defaults.js';
/** Resolves the first mention renderer that owns an icon, in registration order. */
export function resolveMentionIconRenderer(plugins) {
    const configurations = plugins.flatMap((plugin) => (plugin.mentions ?? []).map((configure) => configure(plugin.props ?? EMPTY_OBJECT)));
    if (configurations.length === 0) {
        return undefined;
    }
    return (icon) => {
        if (icon.type !== 'source') {
            return undefined;
        }
        for (const configuration of configurations) {
            const renderedIcon = configuration.renderIcon(icon);
            if (renderedIcon !== undefined) {
                return renderedIcon;
            }
        }
        return undefined;
    };
}
//# sourceMappingURL=resolveMentionIconRenderer.js.map